import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH PROMOTION_USERS_LIST TO EDIT ********************
export const fetchPromotionUsersList = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROMOTION_USERS_LIST_LOADING,
			payload: true
		});

		const { data } = await services.get(`/promotions/${id}/users`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROMOTION_USERS_LIST_SUCCESS,
			payload: { logins: data }
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROMOTION_USERS_LIST_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
